import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppConfigService } from '@app/services/app-config.service';
import { PlanManagerURL, PWOptionURL } from '@app/shared/common/serviceURL';
import { Observable, catchError, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PlanManagerService {
    private baseURL = PlanManagerURL;
    private readonly httpClient = inject(HttpClient);
    private apiUrl = AppConfigService.settings.apiUrl;
    // private PlanManagerURL = PWOptionURL.PlanManagerURL;
    region = '';
    role = '';
    constructor() {
        this.region = localStorage.getItem('selectedRegion') || '';
    }
     getRegion() {
    return (localStorage.getItem('selectedRegion') || '');
  }
    getPlanManagerDetails(
        regionId: string,
        currentPlanID: string
    ): Observable<any> {
        const fullUrl = `${this.apiUrl}/PlanManager/caseInformation/${currentPlanID}/${this.getRegion()}`; //need to change this
        return this.httpClient.get(fullUrl).pipe(
            catchError((error) => {
                console.log('error', error);
                return of([]); // Return empty array instead of throwing error
            })
        );
    }

    // get plan manager table data
    getPlanManagerData(
        planAgeDays: string,
        regionId: string,
        role: string
    ): Observable<any> {
        const fullUrl = `${this.apiUrl}/${this.baseURL.GetAllCaseInformationByPlanAgeDays}/${planAgeDays}/${role}/${this.getRegion()}`; //need to change this
        return this.httpClient.get(fullUrl).pipe(
            catchError((error) => {
                console.log('error', error);
                return of([]); // Return empty array instead of throwing error
            })
        );
    }

    getActivePlansForPlanManager(regionId: string): Observable<any> {
        const fullUrl = `${this.apiUrl}/${this.baseURL.GetActivePlansForUser}/${this.getRegion()}`; //need to change this
        return this.httpClient.get(fullUrl).pipe(
            catchError((error) => {
                console.log('error', error);
                return of([]); // Return empty array instead of throwing error
            })
        );
    }

    savePlan(location: any, selectedPlan: any): Observable<any> {
        this.role = localStorage.getItem('selectedRole') || '';
        const fullUrl = `${this.apiUrl}/${this.baseURL.SetCurrentPlanId}/${selectedPlan}/${this.role}/${location}`;
        return this.httpClient.post(fullUrl, {}).pipe(
            catchError((error) => {
                console.error('Error saving repump approval:', error);
                throw error; // Re-throw the error to be handled by the component
            })
        );
    }

    setActivePlan(regionId: string, planIds: number[]): Observable<any> {
        this.role = localStorage.getItem('selectedRole') || '';
        const fullUrl = `${this.apiUrl}/${this.baseURL.SetOpenedPlanIds}/${this.role}/${this.getRegion()}`;
        return this.httpClient.post(fullUrl, planIds).pipe(
            catchError((error) => {
                console.error('Error setting active plan:', error);
                return of([]); // Return empty array instead of throwing error
            })
        );
    }
    updatePlanManagerDesc(regionId: string, payLoad: any): Observable<any> {
        const fullUrl = `${this.apiUrl}/${this.baseURL.UpdatePlanManagerDesc}/${this.getRegion()}`;
        return this.httpClient.post(fullUrl, payLoad).pipe(
            catchError((error) => {
                console.error(
                    'Error updating plan manager description:',
                    error
                );
                return of([]); // Return empty array instead of throwing error
            })
        );
    }
    closePlans(regionId: string, planIds: number[]): Observable<any> {
        const fullUrl = `${this.apiUrl}/${this.baseURL.ClosePlanByPlanId}/${this.getRegion()}`;
        return this.httpClient.post(fullUrl, planIds).pipe(
            catchError((error) => {
                console.error('Error closing plans:', error);
                return of([]); // Return empty array instead of throwing error
            })
        );
    }

    copyPlan(regionId: string, planIds: number[]): Observable<any> {
        const fullUrl = `${this.apiUrl}/${this.baseURL.CopyPlan}/${this.getRegion()}`;
        return this.httpClient.post(fullUrl, planIds).pipe(
            catchError((error) => {
                console.error('Error copying plan:', error);
                return of([]); // Return empty array instead of throwing error
            })
        );
    }

    saveAsPlan(regionId: string, payload: any): Observable<any> {
        const fullUrl = `${this.apiUrl}/${this.baseURL.SaveAsPlan}/${this.getRegion()}`;
        return this.httpClient.post(fullUrl, payload).pipe(
            catchError((error) => {
                console.error('Error saving plan:', error);
                return of([]); // Return empty array instead of throwing error
            })
        );
    }
    /**
     * Copy plan with custom payload (sourcePlanId, targetDescription, userName)
     */
    copyPlanWithPayload(
        regionId: string,
        payload: {
            sourcePlanId: number;
            targetDescription: string;
            userName: string;
        }
    ): Observable<any> {
        const fullUrl = `${this.apiUrl}/${this.baseURL.CopyPlan}/${this.getRegion()}`;
        return this.httpClient.post(fullUrl, payload).pipe(
            catchError((error) => {
                console.error('Error copying plan with payload:', error);
                return of([]); // Return empty array instead of throwing error
            })
        );
    }

    deletePlan(location: any, payload: any): Observable<any> {
        const fullUrl = `${this.apiUrl}/${this.baseURL.DeletePlan}/${location}`;
        return this.httpClient.post(fullUrl, payload).pipe(
            catchError((error) => {
                console.error('Error deleting plan:', error);
                throw error; // Re-throw the error to be handled by the component
            })
        );
    }

    unlockPlan(userName: any, location: any, payload: any): Observable<any> {
        const fullUrl = `${this.apiUrl}/${this.baseURL.UnlockPlanByPlanId}/${location}`;
        return this.httpClient.post(fullUrl, payload).pipe(
            catchError((error) => {
                console.error('Error unlocking plan:', error);
                throw error; // Re-throw the error to be handled by the component
            })
        );
    }

    keepLocked(location: any, payload: any): Observable<any> {
        const fullUrl = `${this.apiUrl}/${this.baseURL.LockPlanByPlanId}/${location}`;
        return this.httpClient.post(fullUrl, payload).pipe(
            catchError((error) => {
                console.error('Error unlocking plan:', error);
                throw error; // Re-throw the error to be handled by the component
            })
        );
    }
}
